import { render, staticRenderFns } from "./ConfiguracaoWorkflowAprovacao.vue?vue&type=template&id=8c3da792&lang=html&"
import script from "./ConfiguracaoWorkflowAprovacao.vue?vue&type=script&lang=js&"
export * from "./ConfiguracaoWorkflowAprovacao.vue?vue&type=script&lang=js&"
import style0 from "./ConfiguracaoWorkflowAprovacao.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/spa/configuracao/ConfiguracaoWorkflowAprovacao.vue
// module id = 1130
// module chunks = 28